import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MessageService, SharedModule } from 'primeng/api';
import { Button } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import Task from '../../../../types/task/Task';
import { EnumLabelPipe } from '../../pipes/enum-label.pipe';
import { FormatDateTime } from '../../pipes/format-date-time';
import { TaskTypeSeverityPipe } from '../../pipes/task-type-severity.pipe';
import { TaskService } from '../../services/task.service';
import { PageHeaderComponent } from '../shared/page-header/page-header.component';
import { SampleProcessComponent } from '../shared/samples/sample-process/sample-process.component';

@Component({
    selector: 'app-my-tasks',
    imports: [
        PageHeaderComponent,
        Button,
        EnumLabelPipe,
        FormatDateTime,
        RouterLink,
        SharedModule,
        TableModule,
        Tag,
        TaskTypeSeverityPipe,
        SampleProcessComponent
    ],
    templateUrl: './my-tasks.component.html',
    styleUrl: './my-tasks.component.scss'
})
export class MyTasksComponent implements OnInit {

    public tasks: Task[] = [];
    public loading: boolean = false;

    constructor(private taskService: TaskService,
                private messageService: MessageService) {
    }

    /**
     * Initializes the component.
     */
    public ngOnInit(): void {
        this.loadTasks();
    }

    /**
     * Loads the tasks for the user.
     */
    public loadTasks(): void {
        this.loading = true;
        this.taskService.getTasks()
            .then((tasks: Task[]) => this.tasks = tasks)
            .catch((error: any) => {
                console.error('Error loading tasks:', error);
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error loading tasks',
                    detail: 'An error occurred while loading tasks. Please try again later.'
                });
            }).finally(() => this.loading = false);
    }

}
